/**
 * Realtime connection store (client-state, Zustand).
 *
 * Holds the SSE connection lifecycle so the UI can show a live/reconnecting
 * indicator, and the timestamp of the last received event so pages can render
 * "bijgewerkt om HH:MM". Server-state itself stays in TanStack Query — this
 * store only tracks the connection + last-event metadata (per conventions:
 * TanStack Query = server-state, Zustand = client-state).
 *
 * First Zustand store in the app; the `useRealtime` hook owns the EventSource
 * and drives these setters.
 */
import { create } from 'zustand';

export type RealtimeStatus = 'connecting' | 'open' | 'reconnecting' | 'closed';

interface RealtimeState {
  status: RealtimeStatus;
  /** ISO timestamp of the last event received from the server, or null. */
  lastEventAt: string | null;
  /** Type of the last event received (e.g. 'data_refreshed'), or null. */
  lastEventType: string | null;
  setStatus: (status: RealtimeStatus) => void;
  markEvent: (type: string, ts: string) => void;
}

export const useRealtimeStore = create<RealtimeState>((set) => ({
  status: 'connecting',
  lastEventAt: null,
  lastEventType: null,
  setStatus: (status) => set({ status }),
  markEvent: (type, ts) => set({ lastEventType: type, lastEventAt: ts }),
}));
